import { render } from "./EmailTemplateIndex.vue?vue&type=template&id=2d732ba5"
import script from "./EmailTemplateIndex.vue?vue&type=script&lang=js"
export * from "./EmailTemplateIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__